import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './EvTaskDescriptEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import EntityStore from '../../../moreCore/Tools/EntityStore';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import lang from 'dojo/_base/lang';
import MainCatalogSelectV2 from '../MainCatalogSelectV2';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';

class EvTaskDescriptEditorV2 extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    number: MdsLax<InstanceType<typeof NumberInput>>;

    addressExpandableSection: MdsLax<InstanceType<typeof ExpandableSection>>;
    tableContainer: HTMLDivElement;

    selectContainer: HTMLDivElement;
    evTaskDescriptGroupSelect: MdsLax<InstanceType<typeof MainCatalogSelectV2>>;

    tableRowLayout: StaticTable.RowConfig = {
        attributes: ["gDisp_1"],
        colNamesInternal: ["gDisp_1"],
        headings: ["Name"],
    };

    tableLayout: StaticTable.Layout = {
        label: "table",
        name: "table",
        rows: [(this as any).tableRowLayout],
        layoutStyle: "auto"
    }

    addressStore: MdsLax<InstanceType<typeof EntityStore<MainCatalogTypes.EvTaskDescriptAddress>>>;
    addressTable: MdsLax<InstanceType<typeof StaticTable>>;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    private _setTableData(data: Array<MainCatalogTypes.EvTaskDescriptAddress>) {
        this.addressStore.setup(data);
        this.addressTable.setupFromStore(this.addressStore);
    }

    private _setupTable(): void {
        this.addressTable.setLayout(this.tableLayout);
        this.addressTable.addDefaultRowActionButton("delete");

        this.addressTable.setupFromStore(this.addressStore);
        this.addressTable.placeAt(this.tableContainer);
    }



    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);


        var taskGroup = this.getAttributeValue("ref_task_grp.ID");
        this.evTaskDescriptGroupSelect.setCatalog(MainCatalogs_Classes.EvTaskDescriptGroup, this.translate("General_Label_EvTaskDescriptGroup"), taskGroup);


        var addresses: Array<MainCatalogTypes.EvTaskDescriptAddress> = this.getAttributeValue("addresses");
        this._setTableData(addresses);

        this.addressExpandableSection.setMarking(addresses.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.EvTaskDescript;
    }

    private _onStoreChange(e: Array<MainCatalogTypes.EvTaskDescriptAddress>) {
        var diffData = this.addressStore.getDiffData();
        this.setAttributeValue("addressDiffData", diffData);
        this.addressExpandableSection.setMarking(this.addressStore.getCurrentCompleteList().length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onChangeSelect(): void {
        var value = this.evTaskDescriptGroupSelect.getValue();
        this.setAttributeValue("ref_task_grp", value);
    }

    private _onCallbackSED(mode: string, data, items): void {
        items?.forEach((item) => {
            var currentEntity: more.EntityAPIResultExtendedGDisp1 = item.entry.data;
            if (!this._storeHasAddress(currentEntity.ID)) {
                var newAddress: MainCatalogTypes.EvTaskDescriptAddress = {
                    $Displayname: "",
                    Classname: "ht_address_task_description",
                    ClassPrintname: "",
                    gDisp_1: currentEntity.gDisp_1,
                    ID: null,
                    addressID: currentEntity.ID
                }
                this.addressStore.addEntry(newAddress);
            } else {
                this.showToast("Address already in store", "fas fa-warning-triangle")
            }
        });
    }

    private _storeHasAddress(ID: string): boolean {
        var addressList = this.addressStore.getCurrentCompleteList();
        var hasAddress = false;
        addressList.forEach((element) => {
            if (element.addressID === ID) {
                hasAddress = true;
            }
        });
        return hasAddress;
    }

    private _onClickOpenAddressSED(e): void {
        this.loadSelectEntityDialog(e,
            "",
            lang.hitch(this, this._onCallbackSED)
        );
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.addressExpandableSection.setMarking(ExpandableSectionMarkings.hasContent);        this.addressStore = new EntityStore<MainCatalogTypes.EvTaskDescriptAddress>();
        this.addressStore.on("change", lang.hitch(this, this._onStoreChange))
        this.addressTable = new StaticTable();
        this._setupTable();
        this.addressTable.setCyAttribute("EvTaskDescriptEditorV2AddressTable");

        this.evTaskDescriptGroupSelect.placeAt(this.selectContainer);
        this.evTaskDescriptGroupSelect.on("change", lang.hitch(this, this._onChangeSelect))

        this.evTaskDescriptGroupSelect.setCatalog(MainCatalogs_Classes.EvTaskDescriptGroup, this.translate("General_Label_EvTaskDescriptGroup"));

        this.SEDconfigCallfunction = "Webtool__MainCatalogsEditor_EvTaskDescript_SED_GetConfig";
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(EvTaskDescriptEditorV2.prototype, {
  evTaskDescriptGroupSelect: () => (new MainCatalogSelectV2()),
});
export default mdsWidget(EvTaskDescriptEditorV2);
